import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { Registry } from '../../../../platform/registry/common/platform.js';
import { Extensions } from '../../../../platform/quickinput/common/quickAccess.js';
import { QuickCommandNLS } from '../../../common/standaloneStrings.js';
import { ICodeEditorService } from '../../../browser/services/codeEditorService.js';
import { AbstractEditorCommandsQuickAccessProvider } from '../../../contrib/quickAccess/commandsQuickAccess.js';
import { withNullAsUndefined } from '../../../../base/common/types.js';
import { IInstantiationService } from '../../../../platform/instantiation/common/instantiation.js';
import { IKeybindingService } from '../../../../platform/keybinding/common/keybinding.js';
import { ICommandService } from '../../../../platform/commands/common/commands.js';
import { ITelemetryService } from '../../../../platform/telemetry/common/telemetry.js';
import { INotificationService } from '../../../../platform/notification/common/notification.js';
import { EditorAction, registerEditorAction } from '../../../browser/editorExtensions.js';
import { EditorContextKeys } from '../../../common/editorContextKeys.js';
import { IQuickInputService } from '../../../../platform/quickinput/common/quickInput.js';

var StandaloneCommandsQuickAccessProvider = /*#__PURE__*/function (_AbstractEditorComman) {
  _inherits(StandaloneCommandsQuickAccessProvider, _AbstractEditorComman);

  var _super = _createSuper(StandaloneCommandsQuickAccessProvider);

  function StandaloneCommandsQuickAccessProvider(instantiationService, codeEditorService, keybindingService, commandService, telemetryService, notificationService) {
    var _this;

    _classCallCheck(this, StandaloneCommandsQuickAccessProvider);

    _this = _super.call(this, {
      showAlias: false
    }, instantiationService, keybindingService, commandService, telemetryService, notificationService);
    _this.codeEditorService = codeEditorService;
    return _this;
  }

  _createClass(StandaloneCommandsQuickAccessProvider, [{
    key: "activeTextEditorControl",
    get: function get() {
      return withNullAsUndefined(this.codeEditorService.getFocusedCodeEditor());
    }
  }, {
    key: "getCommandPicks",
    value: function getCommandPicks() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.getCodeEditorCommandPicks());

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return StandaloneCommandsQuickAccessProvider;
}(AbstractEditorCommandsQuickAccessProvider);

StandaloneCommandsQuickAccessProvider = __decorate([__param(0, IInstantiationService), __param(1, ICodeEditorService), __param(2, IKeybindingService), __param(3, ICommandService), __param(4, ITelemetryService), __param(5, INotificationService)], StandaloneCommandsQuickAccessProvider);
export { StandaloneCommandsQuickAccessProvider };
Registry.as(Extensions.Quickaccess).registerQuickAccessProvider({
  ctor: StandaloneCommandsQuickAccessProvider,
  prefix: StandaloneCommandsQuickAccessProvider.PREFIX,
  helpEntries: [{
    description: QuickCommandNLS.quickCommandHelp,
    needsEditor: true
  }]
});
export var GotoLineAction = /*#__PURE__*/function (_EditorAction) {
  _inherits(GotoLineAction, _EditorAction);

  var _super2 = _createSuper(GotoLineAction);

  function GotoLineAction() {
    _classCallCheck(this, GotoLineAction);

    return _super2.call(this, {
      id: 'editor.action.quickCommand',
      label: QuickCommandNLS.quickCommandActionLabel,
      alias: 'Command Palette',
      precondition: undefined,
      kbOpts: {
        kbExpr: EditorContextKeys.focus,
        primary: 59
        /* F1 */
        ,
        weight: 100
        /* EditorContrib */

      },
      contextMenuOpts: {
        group: 'z_commands',
        order: 1
      }
    });
  }

  _createClass(GotoLineAction, [{
    key: "run",
    value: function run(accessor) {
      accessor.get(IQuickInputService).quickAccess.show(StandaloneCommandsQuickAccessProvider.PREFIX);
    }
  }]);

  return GotoLineAction;
}(EditorAction);
registerEditorAction(GotoLineAction);